module.exports = __webpack_public_path__ + "img/settings_sub.9b3441ae.jpg";